import React from 'react'
import Bredcom from '../Bredcom/Main'
import First from '../Menservise-deatils/First'

function Main() {
  return (
    <>
      <Bredcom title="Serivces Details" subtitle="Home" subtitledown="Pricing" />
      <First />
    </>
  )
}

export default Main